/**
 * Pick Batch Exception Types
 *
 * These values match the backend PickBatchExceptionType enum.
 * Used for filtering and displaying picking exceptions in the orders grid.
 */
export enum PickBatchExceptionType {
  None = 0,
  NotEnoughStock = 2,
  ProductDamaged = 3,
  ProductNotFound = 4,
  Other = 5,
}
